export const TAGS = 'tags';
export const TOPIC = 'topic';
export const TERMS = 'terms';
export const PRICE_RANGE = 'priceRange';
export const PRICE_FROM = 'priceFrom';
export const PRICE_TO = 'priceTo';
export const AVAILABLE_DATE = 'availableDate';
export const AVAILABLE_TIME = 'availableTime';

export const MIN_PRICE = 0;
export const MAX_PRICE = 300;
export const ALL_CATEGORIES = 'All categories';

export const DEFAULT_AVAILABLE_TIME = 'Any time';
